import type { BillingCustomer, BillingTransaction } from '@common/types/billing';
import axiosInstance from '@/services/axiosInstance';

export async function getBillingTransactions(params: {
    startDate?: string;
    endDate?: string;
    lawFirmId?: number;
    includeTestFirms?: boolean;
}) {
    return axiosInstance.get<BillingTransaction[]>('/api/v1/billing', {
        params,
    });
}

export async function getProspectBilling(prospectId: string) {
    return axiosInstance.get<BillingTransaction[]>(`/api/v1/billing/${prospectId}`);
}

export async function updateBillingPrice(params: {
    prospectId: string;
    templateType: BillingTransaction['templateType'];
    basePrice: number;
}) {
    const { prospectId, ...body } = params;
    return axiosInstance.patch(`/api/v1/billing/${prospectId}/price`, body);
}

export async function getBillingCustomer(lawFirmId: number) {
    return axiosInstance.get<BillingCustomer | null>(`/api/v1/billing/customer/${lawFirmId}`);
}
